module.exports = __webpack_public_path__ + "img/icon-shield-black.8be56a31.svg";